module.exports = __webpack_public_path__ + "static/media/18ECA29.7386f6ea.jpg";